const canonify = name => {
  const splitPattern = /[^a-zA-Z0-9_]/;
  const base = name
    .split(splitPattern)
    .filter(Boolean)
    .join('_')
    .toUpperCase();

  return `SSR_${base}_STATE`;
};

export default canonify;
